module.exports = truncate;

function truncate(fullString, charLimit, openTag, closeTag, prettyEllipsis) {
    if (!fullString || fullString.length <= charLimit) {
        return fullString;
    }

    let lastSpaceInd = 0;
    let countedChars = 0;
    let closeTagNeeded = false;
    let endedWithCloseTag = false;

    for (var i = 0; i < fullString.length; i++) {

        // If the next chars are the openTag, skip them.
        if (i+openTag.length <= fullString.length && fullString.slice(i, i+openTag.length) == openTag) {
            i = i + openTag.length;
            closeTagNeeded = true;
        }

        // If the next chars are the closeTag, skip them.
        if (i+closeTag.length <= fullString.length && fullString.slice(i, i+closeTag.length) == closeTag) {
            i = i + closeTag.length;
            closeTagNeeded = false;
        }

        // Keeps track of last full word iterated so we do not split the final word.
        if (fullString.charAt(i) == ' ') {
            lastSpaceInd = i;
        }

        // Stop iterating if we reach charLimit, leaving room for ellipsis.
        // Keep iterating if close tag is still needed though (do not break in between open and close HTML tags).
        countedChars++;
        if (!closeTagNeeded && countedChars >= charLimit - 3) {
            endedWithCloseTag = countedChars > charLimit - 3;
            break;
        }
    }

    // No need for ellipsis!
    if (countedChars < charLimit - (closeTagNeeded + 3)) {
        return fullString;
    }

    if (!prettyEllipsis) {
        return fullString.slice(0, lastSpaceInd) + '...';
    }

    // Make sure last chars are '...'. Handles cases where there are existing punctuation already at the end of intended slice
    const lastCharInd = endedWithCloseTag ? lastSpaceInd - 1 - closeTag.length : lastSpaceInd - 1;
    for (var i = lastCharInd; i >= 0; i--) {
        if (!/^[.,:;!?\-]/.test(fullString.substring(i,i+1)) && fullString.charAt(i) != ' ') {
            return fullString.slice(0, i + 1) + (endedWithCloseTag ? closeTag : '') + '...';
        }
    }
};